import { useNode } from "@craftjs/core";
import { cn } from "@/lib/utils";
import { applyStyleProps, defaultStyleProps, type ResponsiveStyleProps } from "@/lib/craft/style-props";
import { DividerBlockSettings } from "@/components/craft/settings/DividerBlockSettings";

type DividerBlockProps = {
  color?: string;
  thickness?: number;
  style?: ResponsiveStyleProps;
};

export function DividerBlock({ color = "#e5e0d8", thickness = 1, style = defaultStyleProps() }: DividerBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    id,
  } = useNode((node) => ({ selected: node.events.selected, id: node.id }));
  const { style: inlineStyle, className: styleClass } = applyStyleProps(style, "desktop", id);

  return (
    <hr
      ref={(ref) => { if (ref) connect(drag(ref)); }}
      className={cn("my-6 border-0", `craft-node-${id}`, styleClass, selected && "outline outline-1 outline-dashed outline-primary/30")}
      style={{ ...inlineStyle, height: thickness, backgroundColor: color }}
    />
  );
}

DividerBlock.craft = {
  displayName: "Divider",
  props: { color: "#e5e0d8", thickness: 1, style: defaultStyleProps() },
  rules: { canDrag: () => true },
  related: { settings: DividerBlockSettings },
};
